// removed by extract-text-webpack-plugin
module.exports = {"rating":"_2H5xG","starRating":"_39FPG","starRatingCount":"_3qRxZ"};